// Copies the supplied text to the clipboard
export default function copyToClipboard(text) {
    navigator.clipboard.writeText(text)
}